"use client";

import Image from "next/image";
import { useAction } from "next-safe-action/hooks";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { createAvailabilityNotificationAction } from "@/actions/availability-notifications";
import { useAuthStoreClient } from "@/lib/auth-client";
import { Button } from "@/ui/shadcn/button";
import { Input } from "@/ui/shadcn/input";
import { Label } from "@/ui/shadcn/label";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/ui/shadcn/sheet";
export const AvailabilityNotificationPanel = ({
  isOpen,
  onClose,
  product,
  selectedVariant,
  domain,
  storeBaseUrl
}) => {
  const [email, setEmail] = useState("");

  // Get auth client for this store
  const authClient = useAuthStoreClient(storeBaseUrl);
  const {
    data: session
  } = authClient.useSession();

  // Pre-fill email when panel opens and user is logged in
  useEffect(() => {
    if (isOpen && session?.user?.email) {
      setEmail(session.user.email);
    }
  }, [isOpen, session?.user?.email]);
  const {
    execute,
    isExecuting
  } = useAction(createAvailabilityNotificationAction, {
    onSuccess: () => {
      toast.success("You'll be notified when this product is back in stock!");
      setEmail(session?.user?.email || "");
      onClose();
    },
    onError: ({
      error
    }) => {
      toast.error(error?.serverError ?? "Failed to save notification preference");
    }
  });
  const handleSubmit = e => {
    e.preventDefault();
    if (!email) return;
    execute({
      email,
      productVariantId: selectedVariant.id,
      domain
    });
  };
  return <Sheet open={isOpen} onOpenChange={onClose}>
			<SheetContent side="right" className="w-full max-w-md p-0">
				<div className="flex h-full flex-col">
					<SheetHeader className="border-b px-6 py-4">
						<SheetTitle>Restock Alert</SheetTitle>
					</SheetHeader>

					<div className="flex-1 px-6 py-6">
						<div className="mb-6">
							<div className="flex gap-4">
								{product.images[0] && <Image src={product.images[0]} alt={product.name} width={64} height={64} className="h-16 w-16 rounded-md object-cover" />}
								<div className="flex-1">
									<h3 className="font-medium text-sm">{product.name}</h3>
									{selectedVariant.combinations.length > 0 && <p className="text-sm text-muted-foreground mt-1">
											{selectedVariant.combinations.map(c => `${c.variantValue.variantType.label}: ${c.variantValue.value}`).join(", ")}
										</p>}
								</div>
							</div>
						</div>

						<form onSubmit={handleSubmit} className="space-y-4">
							<div className="space-y-2">
								<Label htmlFor="email">Email address</Label>
								<Input id="email" type="email" placeholder="your@email.com" value={email} onChange={e_0 => setEmail(e_0.target.value)} disabled={!!session?.user?.email} readOnly={!!session?.user?.email} required />
							</div>

							<Button type="submit" className="w-full" disabled={!email || isExecuting}>
								{isExecuting ? "Saving..." : "Alert me when available"}
							</Button>
						</form>

						<p className="text-xs text-muted-foreground mt-4">
							We'll send you an email as soon as this product is back in stock. You can unsubscribe at any
							time.
						</p>
					</div>
				</div>
			</SheetContent>
		</Sheet>;
};